
import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import DemoForm from '../components/DemoForm';
import PageCallToAction from '../components/PageCallToAction';
import { ArrowLeft, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const BookDemo = () => {
  return (
    <DashboardLayout>
      <div className="max-w-3xl mx-auto py-0 px-4 sm:px-6 lg:px-8">

        <div className="text-center mb-0">
          <div className="inline-flex items-center justify-center p-2 bg-primary/10 text-primary rounded-full mb-4">
            <Calendar size={20} />
          </div>
          <h1 className="text-3xl font-bold tracking-tight font-mono">Book a Demo with Our Team</h1>
          <p className="mt-3 text-lg text-muted-foreground max-w-xl mx-auto font-mono">
            Fill out the form below to schedule a personalized demo.
          </p>
        </div>
        
        <div className="bg-card shadow-sm rounded-lg border border-border p-6 sm:p-8">
          <DemoForm />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default BookDemo;
